import { useParams, Link } from "react-router-dom";
import { useLangQuery } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { useSeo } from "@/lib/seo";
import { Reveal } from "@/components/fx/Motion";

export const LEGAL_PAGES = ["shipping", "returns", "privacy", "cookies", "terms"];

export default function Legal({ kind: fixed }) {
  const params = useParams();
  const kind = fixed || params.kind;
  const { t } = useI18n();
  const { data, isLoading } = useLangQuery(["legal", kind], `/legal/${kind}`);
  useSeo(data?.title, data?.intro);
  return (
    <div data-testid={`legal-page-${kind}`} className="max-w-3xl mx-auto px-5 lg:px-10 py-14 lg:py-24">
      <nav className="flex flex-wrap gap-x-5 gap-y-2 mb-10 text-[11px] uppercase tracking-[0.18em] text-white/40">
        {LEGAL_PAGES.map((k) => (
          <Link key={k} data-testid={`legal-nav-${k}`} to={`/${k}`} className={k === kind ? "text-gold" : "hover:text-white transition-colors"}>{t(`legal_${k}`)}</Link>
        ))}
      </nav>
      {isLoading || !data ? <div className="h-64 animate-pulse bg-white/5" /> : (
        <>
          <h1 data-testid="legal-title" className="font-display text-4xl sm:text-5xl mb-6">{data.title}</h1>
          <p className="text-white/70 text-base lg:text-lg leading-relaxed mb-12">{data.intro}</p>
          <div className="space-y-10">
            {data.sections.map((s, i) => (
              <Reveal key={i} delay={Math.min(i * 0.05, 0.3)}>
                <h2 className="font-display text-2xl mb-3 text-white">{s.h}</h2>
                {s.p.map((p, j) => <p key={j} className="text-sm lg:text-base text-white/65 leading-relaxed mb-2">{p}</p>)}
              </Reveal>
            ))}
          </div>
          <p className="mt-14 pt-6 border-t border-white/10 text-xs text-white/40">AJS Luxury FZCO · Dubai, UAE · info@ajsluxury.com</p>
        </>
      )}
    </div>
  );
}
